<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :model="model"
        :options="companies | idNameToValueLabel"
        :disabled="disabled"
        :searching="isLoading"
        @search="autocomplete"
        @input="evt => $emit('input', evt)">
      <template v-slot:no-results>
        {{ $t('components.select.nenhum_resultado') }}:<br/>
        "{{ stringSearch }}"<br/>
      </template>
    </SelectComponent>
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SelectCoreCompanies",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'corecompanies/isLoading',
      companies: 'corecompanies/all',
    })
  },
  data() {
    return {
      stringSearch: '',
      awaitingSearch: false
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/search',
    ]),
    async autocomplete(string) {
      this.stringSearch = string
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('core_companies.name', string).map(async array => {
            await this['corecompanies/search']({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    },
  },
  mounted() {
    this['corecompanies/search']()
  }
}
</script>